module.exports = __webpack_public_path__ + "services-large.jpg?8045a81c8dae146b694d064c0b7e35b2";


//////////////////
// WEBPACK FOOTER
// ./src/images/services-large.jpg
// module id = 302
// module chunks = 0